import React, { useContext, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import 'prismjs/components/prism-clike';
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-jsx';
import 'prismjs/components/prism-markup';
import Editor from 'react-simple-code-editor';
import './prismjson.css';

import { Context } from '../../providers/TemplateProvider';
import { CLOSE_SHIPMENT_INFO_EDITOR, PREVIEW_LOADED, PREVIEW_LOADING, SAVE_PREVIEW_SHIPMENT_INFO } from '../../reducers/TemplateReducer';
import { previewTemplate } from '../../repositories/HttpRepository';

export default function ShipmentInfoEditor(props) {
  const { state, dispatch } = useContext(Context);
  const [code, setCode] = useState(JSON.stringify(state.shipmentInfo, undefined, 4));

  const closeEditor = () => {
    setCode(JSON.stringify(state.shipmentInfo, undefined, 4));
    dispatch({ type: CLOSE_SHIPMENT_INFO_EDITOR });
  };

  const saveCode = () => {
    if (state.isLoadingPreview) return;
    try {
      dispatch({ type: PREVIEW_LOADING });
      const shipmentInfo = JSON.parse(code);
      const payload = { html: state.rawHtml, shipment_info: shipmentInfo };
      previewTemplate(payload).then((resp) => {
        if (resp.ok) {
          dispatch({
            type: PREVIEW_LOADED,
            data: resp.data,
            rawHtml: state.rawHtml,
          });
          dispatch({ type: SAVE_PREVIEW_SHIPMENT_INFO, shipmentInfo });
        }
      });
    } catch (e) {
      // console.log(e);
    }
  };

  return (
    <div>
      <Dialog open={state.openShipmentInfoEditor} onClose={closeEditor} scroll={'paper'} aria-labelledby="scroll-dialog-title" aria-describedby="scroll-dialog-description">
        <DialogTitle id="scroll-dialog-title">Edit Info</DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
            <Editor
              value={code}
              onValueChange={(code) => {
                // no-dd-sa:jsx-react/setstate-same-var
                setCode(code);
              }}
              highlight={(code) => highlight(code, languages.json)}
              padding={10}
              className="container__editor"
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeEditor} color="primary">
            Cancel
          </Button>
          <Button onClick={saveCode} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
